import { render, staticRenderFns } from "./BulletinBoard.vue?vue&type=template&id=5b9ea740&scoped=true&"
import script from "./BulletinBoard.vue?vue&type=script&lang=js&"
export * from "./BulletinBoard.vue?vue&type=script&lang=js&"
import style0 from "./BulletinBoard.vue?vue&type=style&index=0&id=5b9ea740&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9ea740",
  null
  
)

export default component.exports